import { DialogComponent } from './../../../shared/components/dialog/dialog.component';
import { ChangeDetectionStrategy, Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'osn-cxb-remove-file-confirmation-dialog',
  templateUrl: './remove-file-confirmation-dialog.component.html',
  styleUrls: ['./remove-file-confirmation-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RemoveFileConfirmationDialogComponent {
  @ViewChild(DialogComponent) private readonly dialog: DialogComponent;

  constructor(@Inject(MAT_DIALOG_DATA) public data?: string) {}

  public onCancelClick(): void {
    this.dialog.closeDialog(false);
  }

  public onDeleteClick(): void {
    this.dialog.closeDialog(true);
  }
}
